import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;

  background: rgba(0, 0, 0, 0.45);

  display: flex;
  justify-content: flex-end;

  z-index: 99999;
`;

export const Drawer = styled.div`
  width: 75%;
  height: 100vh;

  background: ${({ theme }) => theme.landing.cardBg};

  display: flex;
  flex-direction: column;

  position: relative;

  box-shadow: -10px 0 25px rgba(0, 0, 0, 0.12);

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 18px;
  right: 18px;

  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  background: transparent;
  color: ${({ theme }) => theme.landing.textSecondary};
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
    color: ${({ theme }) => theme.landing.text};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  padding: 28px;

  border-bottom: 1px solid ${({ theme }) => theme.landing.cardBorder};
`;

export const IconWrapper = styled.div`
  width: 54px;
  height: 54px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: ${({ theme }) => theme.landing.background};
`;

export const FileInfo = styled.div`
  flex: 1;
`;

export const FileName = styled.h3`
  margin: 0;
  font-size: 18px;
`;

export const FileMeta = styled.div`
  margin-top: 6px;
  color: ${({ theme }) => theme.landing.textSecondary};
  font-size: 13px;
`;

export const Body = styled.div`
  flex: 1;
  overflow: auto;
  padding: 24px;
`;

export const PreviewFrame = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 800px;

  border: none;
`;

export const PreviewImage = styled.img`
  width: 100%;
  border-radius: 10px;
`;

export const EmptyPreview = styled.div`
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 18px;

  color: ${({ theme }) => theme.landing.textSecondary};

  h3 {
    margin: 0;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
`;
